import script from "./ReportsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsIndex.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__